import { Injectable } from '@angular/core';

@Injectable()
export class InsightsClariService {
	constructor() {}

	getSugestions(): InsightSugestion[] {
		return [
			{
				title: 'INSIGHTS.SUGESTION_RETENTION',
				link: 'https://office.zenklub.com.br/clari/pro/?intent=ReterClientes',
				value: 'retain_customers',
			},
			{
				title: 'INSIGHTS.SUGESTION_QUANTITY',
				link: 'https://office.zenklub.com.br/clari/pro/?intent=MaisClientes',
				value: 'more_customers',
			},
			{
				title: 'INSIGHTS.SUGESTION_PROMPTUARY',
				link: 'https://office.zenklub.com.br/clari/pro/?intent=ProntuarioQualidade',
				value: 'quality_prontuary',
			},
			{
				title: 'INSIGHTS.SUGESTION_EVALUATIONS',
				link: 'https://office.zenklub.com.br/clari/pro/?intent=MelhoresAvaliacoes',
				value: 'improve_reviews',
			},
			{
				title: 'INSIGHTS.SUGESTION_PROFILE',
				link: 'https://office.zenklub.com.br/clari/pro/?intent=PerfilCampeao',
				value: 'champion_profile',
			},
		];
	}
}

export interface InsightSugestion {
	title: string;
	link: string;
	value: string;
}
